import React from 'react'
import { getUrlParams } from '../../Services/Utils'
import { useNavigate } from 'react-router-dom'
import { Tabs, TabHeader, Flex } from '../../Components'
import TabDevices from './TabDevices'

const getTabs = () => [
  { id: 0, icon: 'tablet', title: 'Dispositivi associati', content: <TabDevices /> }
]

export default function Devices () {
  const tab = getUrlParams('tab')
  const navigate = useNavigate()
  const currentTab = parseInt(tab) || 0

  return (
    <Flex fw>
      <Tabs
        style={{ width: '100%', height: '100%', padding: 20 }}
        onTabSelection={(e) => navigate('/?tab=' + e)}
        currentTab={currentTab}
      >
        {getTabs()?.map((tab, index) => (
          <TabHeader
            title={tab?.title}
            key={index}
            index={index}
            icon={tab?.icon}
          >
            {tab?.content}
          </TabHeader>
        ))}
      </Tabs>
    </Flex>
  )
}
